'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchActionPattern = exports.mergeActionPatterns = exports.proxyReducer = exports.proxyObject = exports.arrayze = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _lodash = require('lodash.mapvalues');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

var arrayze = exports.arrayze = function arrayze(a) {
  return Array.isArray(a) ? a : [a];
}; // Proxy an object of fucntions


var proxyObject = exports.proxyObject = function proxyObject(obj, proxy) {
  if (typeof proxy === 'function') {
    return _extends({}, obj, proxy(obj));
  }

  if ((typeof proxy === 'undefined' ? 'undefined' : _typeof(proxy)) === 'object') {
    return _extends({}, obj, (0, _lodash2.default)(proxy, function (proxyFn) {
      return proxyFn(obj);
    }));
  }

  return obj;
};

var proxyReducer = exports.proxyReducer = function proxyReducer(reducer, proxyFn) {
  if (typeof proxyFn === 'function') {
    return proxyFn(reducer);
  }

  return reducer;
};

var mergeActionPatterns = exports.mergeActionPatterns = function mergeActionPatterns() {
  for (var _len = arguments.length, patterns = Array(_len), _key = 0; _key < _len; _key++) {
    patterns[_key] = arguments[_key];
  }

  return patterns.reduce(function (finalPattern, pattern) {
    return [].concat(_toConsumableArray(finalPattern), _toConsumableArray(arrayze(pattern)));
  }, []);
};

var matchActionPattern = exports.matchActionPattern = function matchActionPattern(action, pattern) {
  return pattern === '*' || arrayze(pattern).indexOf(action.type) !== -1;
};